export const FormHelperText = {
  baseStyle: {
    color: 'grey.300',
  },
}
